import axiosIns from "@/api/axios";

export const GET_NOTIFICATION_TEMPLATES = (query) => {
  let url = "/notification-templates";

  if (query && Object.keys(query).length > 0) {
    const params = new URLSearchParams(query).toString();
    url += `?${params}`;
  }

  return axiosIns.get(url);
};

export const GET_NOTIFICATION_TEMPLATE_DETAIL = (id) => {
  return axiosIns.get(`/notification-templates/${id}`);
};

export const UPDATE_NOTIFICATION_TEMPLATE = ({ id, data }) => {
  return axiosIns.put(`/notification-templates/${id}`, data);
};

export const PREVIEW_NOTIFICATION_TEMPLATE = ({ id, data }) => {
  return axiosIns.post(`/notification-templates/${id}/preview`, data);
};

export const GET_MODULE_TYPES = () => {
  return axiosIns.get(`/module-types?all=true`);
};
